// Helpers for reasoning about Stripe subscription status values.
// Centralizes the status arrays so we don't sprinkle .includes() everywhere.

export const ACTIVE_STATUSES = ['active', 'trialing'];
export const ACTIVE_OR_CANCELING_STATUSES = ['active', 'trialing', 'canceling'];

export const isSubscriptionActive = (status) => ACTIVE_STATUSES.includes(status);
export const isSubscriptionActiveOrCanceling = (status) =>
  ACTIVE_OR_CANCELING_STATUSES.includes(status);

// Clamp a used/limit ratio into a 0-100 percentage. Safe against zero/undefined.
export const getProgressPercent = (used, limit) =>
  Math.min(100, ((used || 0) / Math.max(limit || 1, 1)) * 100);
